import React from 'react'
import { lazy } from 'react'

const NotFoundPage = lazy(() => import('./NotFoundPage'))

const SpecialRouting = [
  {
    element: <NotFoundPage />,
    path: 'not-found',
  },
]

export default SpecialRouting
